import { ProjectId, TeamId, WorkspaceId } from "../../core";
import {
  GlobalRoleName,
  ProjectRoleName,
  RoleV2,
  WorkspaceRoleName
} from "../types.generated";
import { unsafeRoleV2 } from "./internal";

export function globalRoleV2(name: GlobalRoleName): RoleV2 {
  return unsafeRoleV2(`G:${name}`);
}

export function workspaceRoleV2(
  name: WorkspaceRoleName,
  workspaceId: WorkspaceId
): RoleV2 {
  return unsafeRoleV2(`W:${name}:${workspaceId}`);
}

export function projectRoleV2(
  name: ProjectRoleName,
  projectId: ProjectId
): RoleV2 {
  return unsafeRoleV2(`P:${name}:${projectId}`);
}

export function teamRoleV2(name: ProjectRoleName, teamId: TeamId): RoleV2 {
  return unsafeRoleV2(`T:${name}:${teamId}`);
}

export const superuser: RoleV2 = globalRoleV2("Superuser");

export function workspaceInactiveV2(workspaceId: WorkspaceId): RoleV2 {
  return workspaceRoleV2("Inactive", workspaceId);
}

export function workspaceActiveV2(workspaceId: WorkspaceId): RoleV2 {
  return workspaceRoleV2("Active", workspaceId);
}

export function workspaceAdminV2(workspaceId: WorkspaceId): RoleV2 {
  return workspaceRoleV2("Admin", workspaceId);
}

export function workspaceBillingV2(workspaceId: WorkspaceId): RoleV2 {
  return workspaceRoleV2("Billing", workspaceId);
}

export function projectMemberV2(projectId: ProjectId): RoleV2 {
  return projectRoleV2("Member", projectId);
}

export function projectSurveyorV2(projectId: ProjectId): RoleV2 {
  return projectRoleV2("Surveyor", projectId);
}

export function projectApproverV2(projectId: ProjectId): RoleV2 {
  return projectRoleV2("Approver", projectId);
}

export function projectCoordinatorV2(projectId: ProjectId): RoleV2 {
  return projectRoleV2("Coordinator", projectId);
}

export function teamMemberV2(teamId: TeamId): RoleV2 {
  return teamRoleV2("Member", teamId);
}

export function teamSurveyorV2(teamId: TeamId): RoleV2 {
  return teamRoleV2("Surveyor", teamId);
}

export function teamApproverV2(teamId: TeamId): RoleV2 {
  return teamRoleV2("Approver", teamId);
}

export function teamCoordinatorV2(teamId: TeamId): RoleV2 {
  return teamRoleV2("Coordinator", teamId);
}
